import { useState } from 'react'

export function useSelectedErroProscessamento() {
  const [selectedsErroProcessamento, setSelectedsErroProcessamento] = useState<number[]>([])
  return { selectedsErroProcessamento, setSelectedsErroProcessamento }
}
